import InteractiveMapContainer from '../../../../components/containers/InteractiveMapContainer';
import preloadCustomProps from '../../../utils/preloads/preloadInteractiveMap';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'interactive-map',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: InteractiveMapContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
